/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'mic-fill': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M5 3a3 3 0 016 0v5a3 3 0 01-6 0z"/><path pid="1" d="M3.5 6.5A.5.5 0 014 7v1a4 4 0 008 0V7a.5.5 0 011 0v1a5 5 0 01-4.5 4.975V15h3a.5.5 0 010 1h-7a.5.5 0 010-1h3v-2.025A5 5 0 013 8V7a.5.5 0 01.5-.5"/>',
    },
});
